import React, { useState, useEffect, useRef } from 'react';
//import {Link} from 'react-router-dom';
import { connect } from 'react-redux';
//import Table from 'react-bootstrap/Table';
import Card from 'react-bootstrap/Card';
import Nav from 'react-bootstrap/Nav';

import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';

import UserDataService from '../services/user-activities';
import { withRouter } from 'react-router';

//import { TOTAL_TICKET_COUNT, OPEN_TICKET_COUNT } from '../features/actions/Is-Logged-Actions';

import { Redirect } from 'react-router';

import Container from 'react-bootstrap/Container';
import {
    Table,
    ScrollArea,
    UnstyledButton,
    Group,
    Grid,
    Text,
    Textarea,
    Center,
    TextInput,
    rem,
    keys,
    Button,
    Paper,
    Pill,
    Select,
    Switch,
    Tooltip,
    Flex,
    Modal
} from '@mantine/core';

import Navbar from './Navbar';

import { DateTimePicker } from '@mantine/dates';

import { IconEdit, IconPencil, IconX } from "@tabler/icons-react";

import dayjs from 'dayjs';

import { useSelector, useDispatch } from 'react-redux';

import SoftwareAssetDataService from '../services/software-asset-activities';

import ProjectDataService from '../services/project-activities';

import { useHistory, useParams } from 'react-router-dom';

//import { LOGOUT } from '../features/actions/Is-Logged-Actions';

export default function EditProject({LOGOUT, onLogout}) {

    const history = useHistory();
    
    const loggedStatus = useSelector(state => state.logged);

    const { id } = useParams();
    
    const [customerId, setCustomerId] = useState(0);
    const [customerName, setCustomerName] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [currentTask, setCurrentTask] = useState("");
    const [nextSteps, setNextSteps] = useState("");
    //const [assignedToId, setAssignedToId] = useState(0);
    const [assignedToName, setAssignedToName] = useState("");
    const [status, setStatus] = useState("");
    const [lastUpdate, setLastUpdate] = useState("");
    const [teamMember, setTeamMember] = useState("");

    const [customers, setCustomers] = useState(null);
    //const [employees, setEmployees] = useState(null);
    const [teamMemberList, setTeamMemberList] = useState([]);


    const [canSeeMissingCustomerError, setCanSeeMissingCustomerError] = useState(false);
    const [show_delete_project_modal, setShowDeleteProjectModal] = useState(false);



    function addTeamMember() {
        let currentList = teamMemberList;

        // add the current value from the teamMember state variable
        currentList.push(teamMember);

        // set the team member list to the original + the latest one entered
        setTeamMemberList(currentList);

        // reset team member back to ""
        setTeamMember("");
    }

    function removeTeamMember(nameToRemove) {
        const updatedTeamList = teamMemberList.filter(item => item.toLowerCase() !== nameToRemove.toLowerCase());

        setTeamMemberList(updatedTeamList);
    }


    function convertDateToMySQL(date) {
        try {
            const mysqlFormat = dayjs(date).format('YYYY-MM-DD HH:mm:ss');
            return mysqlFormat;
        }

        catch {
            return "";
        }
    }

    function mysqlDateTimeToDate(mysqlDateTime) {
        // "2026-01-27 12:58:00"
        const [datePart, timePart] = mysqlDateTime.split(" ");
        const [year, month, day] = datePart.split("-").map(Number);
        const [hour, minute, second] = timePart.split(":").map(Number);
      
        // month is 0-based in JS Date
        return new Date(year, month - 1, day, hour, minute, second);
    }

    // look for the id of the customer based on their name. on first load we're providing a non-state version because the state isn't ready yet
    const getCustomerId = (nameToFind, customerList = customers) => {
        const customer = customerList.find(customer => customer.name === nameToFind);
        return customer ? customer.id : null; 
    };

    async function handleCustomerChange(newName) {
        let customerId = getCustomerId(newName);
        setCustomerId(customerId);
        setCustomerName(newName);

        //let projects = await getProjects();

        //setProjects(projects);
    }


    function setDefaults(project, tempCustomers) {
        console.log("project received for defaulting: ", project);
        
        // convert necessary values for display

        let dateObject = "";
        if(project.last_update && project.last_update !== null && project.last_update !== "") {
            console.log("Trying to convert date");
            dateObject = mysqlDateTimeToDate(project.last_update);
        }

        console.log("Trying to get customer id")
        let customerId = getCustomerId(project.customer_name, tempCustomers);       // passing tempCustomers because the state version of list isn't ready yet

        let teamMemberArray = [];

        if(project.team_members && project.team_members.length > 0) {
            teamMemberArray = project.team_members.split(", ");
        }

        console.log("Team member array: ", teamMemberArray);


        // call the various set functions for the component

        setCustomerId(customerId);
        setCustomerName(project.customer_name);
        setTitle(project.title);
        setDescription(project.description);
        setCurrentTask(project.current_task);
        setNextSteps(project.next_steps);
        setAssignedToName(project.currently_assigned_to);
        setStatus(project.status);
        
        if(dateObject !== "") {
            setLastUpdate(dateObject);
        }

        // else {
        //     setLastUpdate(null);
        // }
            
        if(teamMemberArray && teamMemberArray.length > 0) {
            setTeamMemberList(teamMemberArray);
        }
    }

    useEffect(() => {
        const loadData = async () => {
            //console.log("Value for loggedStatus: ", loggedStatus);
            SoftwareAssetDataService.getCustomers(loggedStatus.primary_tenant_id).then(response => {
                console.log(response);
                setCustomers(response.data.results);

                let tempCustomers = response.data.results;      // needed for setting defaults before customer state is availablle

                // get the specific details of this project and set defaults

                ProjectDataService.getSpecificProject(id).then(response => {
                    console.log("Response from get project: ", response);

                    // set individual default values using response.data
                    try {
                        setDefaults(response.data.results[0], tempCustomers);       // passing tempCustomers as the state version of customers isn't ready yet
                    }

                    catch{
                        console.log("error setting defaults");
                    }

                })
                .catch(e => {
                    console.log(e);
                })
            })
            .catch(e => {
                console.log(e);
            });
        }

        loadData();
    }, []);

    async function submitForm() {

        if(customerId && customerId !== 0) {
            setCanSeeMissingCustomerError(false);

            console.log("Going to submit form with the following details");

            console.log("Managing tenant id: ", loggedStatus.primary_tenant_id);

            console.log("Customer id: ", customerId);
            console.log("Title: ", title);
            console.log("Description: ", description);
            console.log("Current Task: ", currentTask);
            console.log("Next Steps: ", nextSteps);
            
            console.log("Assigned To: ", assignedToName);
            console.log("Status: ", status);
            console.log("Last Update: ", lastUpdate);

            console.log("Last Update - converted to MySQL: ", convertDateToMySQL(lastUpdate));
            
            console.log("Team Member List: ", teamMemberList);

            
            let data = {
                projectId: id,
                managingTenantId: loggedStatus.primary_tenant_id,
                customerId: customerId && customerId !== "" ? parseInt(customerId) : 0,
                title: title,
                description: description,
                currentTask: currentTask,
                nextSteps: nextSteps,
                assignedTo: assignedToName,
                status: status,
                lastUpdate: lastUpdate ? convertDateToMySQL(lastUpdate) : "",
                teamMemberList: teamMemberList
            }

            console.log("Submission as object: ", data);


            ProjectDataService.editProject(data).then(response => {

                console.log("Response from add project: ", response);

                // navigate back to the projects list page
                history.push(`/projects`);

            });
        }

        else {
            console.log("Must select a customer");
            setCanSeeMissingCustomerError(true);
        }

    }

    async function deleteProject() {

        ProjectDataService.deleteProject(id).then(response => {
            // navigate back to the projects list page
            history.push(`/projects`);
        })
        .catch(e => {
            console.log(e);
        });
    }


    if (!loggedStatus.loggedIn) {
            return (
                <Redirect to='/' />
            );
    }

    return (
        <>
            <Navbar pageTitle={"Edit Project"} />
            <div className="container mt-3" style={{ paddingTop: "15px" }}></div>
            <Container fluid pt="20px" >
                <Paper withBorder p="md" radius="md" w="100%" mb="sm" display="inline-block">
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: "15px" }}>
                        <Button color="red" onClick={() => setShowDeleteProjectModal(true)}>Delete</Button>
                    </div>
                    <Form>
                        <Form.Row>
                            <Form.Group as={Col}>
                            <Select 
                                label="Customer"
                                placeholder="Pick value"
                                data={
                                    customers && customers.map((customer) => (
                                        // {value: customer.id.toString(), label: customer.name}
                                        customer.name
                                    ))
                                }
                                value={customerName && customerName!== null ? customerName : ""}
                                onChange={(e) => handleCustomerChange(e)}
                                required
                                allowDeselect={false}
                            />
                            </Form.Group>
                            
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Title"
                                    placeholder='Input a value'
                                    value={title && title !== null ? title : ""}
                                    onChange={(event) => setTitle(event.currentTarget.value)}
                                />
                            </Form.Group>
                            
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Textarea 
                                    label="Description"
                                    placeholder='Input a value'
                                    value={description && description !== null ? description : ""}
                                    onChange={(event) => setDescription(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Current Task"
                                    placeholder='Input a value'
                                    value={currentTask && currentTask !== null ? currentTask : ""}
                                    onChange={(event) => setCurrentTask(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Next Steps"
                                    placeholder='Input a value'
                                    value={nextSteps && nextSteps !== null ? nextSteps : ""}
                                    onChange={(event) => setNextSteps(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <TextInput 
                                    label="Currently Assigned To"
                                    placeholder='Input a value'
                                    value={assignedToName && assignedToName !== null ? assignedToName : ""}
                                    onChange={(event) => setAssignedToName(event.currentTarget.value)}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <Select 
                                    label="Status"
                                    data={['In Progress', 'On Hold', 'Complete']}
                                    value={status && status !== null ? status : ""}
                                    onChange={setStatus}
                                />
                            </Form.Group>
                            <Form.Group as={Col}>
                                <DateTimePicker 
                                    label="Last Updated"
                                    placeholder="Pick date and time"
                                    valueFormat={"MM / DD / YYYY hh:mm A"}
                                    value={lastUpdate && lastUpdate !== null ? lastUpdate : ""}
                                    onChange={setLastUpdate}
                                />
                            </Form.Group>
                        </Form.Row>
                        <Form.Row>
                            <Form.Group as={Col}>
                                <span style={{ display: "inline-block", width: "50%" }}>
                                    <TextInput 
                                        label="Add Project Team Member"
                                        placeholder='Input a value'
                                        value={teamMember}
                                        onChange={(event) => setTeamMember(event.currentTarget.value)}
                                    />
                                </span>
                                <span style={{ display: "inline-block", paddingLeft: "10px", cursor: "pointer" }}>
                                    <Button onClick={() => addTeamMember()}>Add</Button>
                                </span>
                            </Form.Group>
                        </Form.Row>
                    </Form>
                    {teamMemberList && teamMemberList.map((name, index) => (
                        <div key={`member-${index}`}>
                            <span style={{paddingRight: "15px"}}><IconX color="red" style={{cursor: "pointer"}} onClick={() => removeTeamMember(name)}/></span><Text size="sm" span>{name}</Text>
                        </div>
                    ))}

                    {canSeeMissingCustomerError ?
                        <Text c="red" ta="center">Error: A customer selection is required to create a project.</Text>
                        :
                        undefined
                    }

                    <div style={{textAlign: 'center', marginTop: "50px"}}>
                        <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => history.push('/projects')} className="gothamNarrowFont">Cancel</Button></span>
                        <span><Button id="newDepartmentFormOkButton" onClick={() => submitForm()} className="gothamNarrowFont">Submit</Button></span>
                    </div>
                </Paper>
            </Container>

            {/* This is for the confirm delete project modal */}
            <Modal
                opened={show_delete_project_modal}
                onClose={() => setShowDeleteProjectModal(false)}
                size="lg"
                centered
                closeOnClickOutside={false}
                withCloseButton={false}
            >
                <div style={{textAlign: "center", marginBottom: '30px'}}><Text size="xl">Are you sure you want to delete this project?</Text></div>
                <div style={{textAlign: 'center', marginTop: "50px"}}>
                    <span style={{marginRight: "150px"}}><Button variant="filled" color="gray" onClick={() => setShowDeleteProjectModal(false)}>Cancel</Button></span>
                    <span><Button color="red" onClick={() => deleteProject()}>Delete</Button></span>
                </div>
            </Modal>
        </>
    );
}